import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useMe } from '../../../shared/hooks/useMe';
import { isContractReviewEnabled } from '../../../shared/utils/features';
import { canAccessContractReview } from '../../../shared/permissions/capabilities';

/**
 * When contract review is enabled, only users with contract:read or contract:write
 * may open /contract-review/* (matches backend route permissions).
 */
const ContractReviewGate: React.FC = () => {
  const { me, loading } = useMe();

  if (!isContractReviewEnabled()) {
    return <Navigate to="/" replace />;
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!canAccessContractReview(me)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Outlet />;
};

export default ContractReviewGate;
